// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"b8f65e5f","178":"f58d4d91","442":"03d7b5a8","444":"0ad19736","453":"bb828c5d"}[chunkId] + ".chunk.js";
};